import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './auth';
import { SsoResolver } from './auth/sso.resolver';
import { CfDocumentSecuredSessionComponent } from './components/cf-document-secured-session/cf-document-secured-session.component';
import { CfDocumentComponent } from './components/cf-document/cf-document.component';
import { CfSignatureQrComponent } from './components/cf-signature-qr/cf-signature-qr.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { PathResolveService } from './components/not-found/path-resolve.service';
import { SsoComponent } from './components/sso/sso.component';
import { ThanksForSigningComponent } from './components/thanks-for-signing/thanks-for-signing.component';
import { CFDocumentSecuredSessionResolver } from './services/documents/cf-document-secured-session.resolver';
import { CFDocumentTypesResolver } from './services/documents/cf-document-types.resolver';
import { CFDocumentResolver } from './services/documents/cf-document.resolver';
import { CFSignatureTypesResolver } from './services/signatures/cf-signature-types.resolver';

const appRoutes: Routes = [
    {
        path: 'load',
        loadChildren: () => import('./app.module').then((m) => m.AppModule)
    },

    { path: 'login', component: LoginComponent },

    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'thanks-for-signing', component: ThanksForSigningComponent },
    {
        path: 'cf-document',
        component: CfDocumentComponent,
        canActivate: [AuthGuard],
        resolve: {
            documentTypes: CFDocumentTypesResolver,
            signatureTypes: CFSignatureTypesResolver
        }
    },
    {
        path: 'cf-document/:documentType/:documentNumber/:companyId',
        component: CfDocumentComponent,
        canActivate: [AuthGuard],
        resolve: {
            documentTypes: CFDocumentTypesResolver,
            signatureTypes: CFSignatureTypesResolver
        }
    },
    {
        path: 'cf-signature-qr/:documentType/:documentNumber/:companyId/:signatureId',
        component: CfSignatureQrComponent,
        canActivate: [AuthGuard],
        resolve: {
            document: CFDocumentResolver
        }
    },
    {
        path: 'cf-document-secured-session',
        component: CfDocumentSecuredSessionComponent,
        resolve: {
            encodedSessionData: CFDocumentSecuredSessionResolver,
            signatureTypes: CFSignatureTypesResolver,
            documentTypes: CFDocumentTypesResolver
        }
    },
    {
        path: 'sso/:ssoId',
        component: SsoComponent,
        resolve: { encodedJwt: SsoResolver }
    },

    {
        path: '**',
        component: NotFoundComponent,
        resolve: { path: PathResolveService }
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {
            preloadingStrategy: PreloadAllModules
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
